import React from 'react';

const ModalContentCompareProduct = React.createClass({
    render() {
        return (
            <div>
                <h3>Landlords Insurance+</h3>
                <p>Our Landlords Insurance+ policy comes with a range of cover options.</p>

                <h4>Buildings insurance</h4>
                <p>Our buildings insurance includes cover for damage to the property and associated loss of rent or re-letting costs you may be faced with after insured damage; plus &pound;5m property owner's liability and &pound;10m employer's liability.<br />
                    <a className="underline primary-colour" href="https://homelet.co.uk/landlord-insurance/products/buildings" target="_blank">Find out more</a></p>

                <h4>Contents insurance</h4>
                <p>We offer two levels of contents cover, Full and Limited. Full cover has been designed to address risks more associated with furnished lets. Limited is restricted to cover items more associated with unfurnished lets.
                Both options offer replacement of your contents, new for old.<br />
                    <a className="underline primary-colour" href="https://homelet.co.uk/landlord-insurance/products/contents-cover" target="_blank">Find out more</a></p>
            </div>
        );
    }
});

export default ModalContentCompareProduct;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentCompareProduct.js
 **/